export function isPaidMember(membership) {
  return !!membership && membership !== "expired";
}